<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}數字滑桿題
    </template>
    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-model="ques.cnName"
        v-on:click="checkDef()"
        class="peter-text"
      ></v-textarea>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>

      <v-row v-if="isEdit">
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            label="最小值"
            v-model="ques.miniNum"
            :max="ques.maxiNum"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            label="區間"
            v-model="ques.numInterval"
            :max="ques.maxiNum - ques.miniNum"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            label="區間數"
            v-model="level"
            :min="0"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-text-field
            dense
            disabled=""
            label="最大"
            v-model="ques.maxiNum"
            outlined
            class="centered-input peter-text"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>
      目前答案 ({{ ques.miniNum }}-{{ ques.maxiNum }})：{{ ques.value }}
      <v-slider
        v-model="ques.value"
        :min="ques.miniNum"
        :max="ques.maxiNum"
        :step="ques.numInterval"
      ></v-slider>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  data() {
    return {
      level: 1 // 區間數
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: () => {
        return {
          numInterval: 1,
          title: '數字滑桿題',
          cnName: '數字滑桿題題目內容',
          miniNum: 0,
          maxiNum: 100,
          value: 50
        }
      }
    }
  },
  computed: {
    miniNum() {
      return this.ques.miniNum
    },
    numInterval() {
      return this.ques.numInterval
    },
     QType() {
      return this.$store.state.QType
    },
  },
  watch: {
    level() {
      this.calculateMax()
      // 確保區間數不小於 0
      if (this.level < 0) this.level = 0
    },
    miniNum() {
      this.calculateMax()
    },
    numInterval() {
      this.calculateMax()
    }
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    calculateMax() {
      this.ques.maxiNum = parseInt(this.ques.miniNum) + this.level * this.ques.numInterval
    },
    checkDef() {
      if (this.QType.SLIDER.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }      
    }
  },
  created() {
    // 調整區間數
    this.level =
      (parseInt(this.ques.maxiNum) - parseInt(this.ques.miniNum)) /
      parseInt(this.ques.numInterval)
  }
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
